export const constructWebSocketUrlOcrStatus = (ctxId: string) => {
  let protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  let host = window.location.host;
  let path = "/api/ocrLabs/ws/status/" + ctxId;
  if (host.includes("localhost:3000")) {
    host = host.replace("3000", "44336"); // Replace port for local development
    protocol = "wss:";
  }
  return `${protocol}//${host}${path}`;
}